import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { viewVisited } from '../actions';
import { getIsViewVisited } from '../selectors';

/**
 * Hook for keeping track if the view has been visited before as well as
 * registering it as visited.
 *
 * The view is marked as visited once the component has been mounted and the
 * view now longer is fetching data (controlled using the isFetching param).
 *
 * @param view View user is visiting
 * @param isFetching Is data currently being fetched for the view
 * @returns {{isViewVisited: *}}
 */
const useViewVisited = (view, isFetching) => {
  const dispatch = useDispatch();
  const [isMounted, setIsMounted] = useState(false);
  const isViewVisited = useSelector(getIsViewVisited(view));

  useEffect(() => {
    if (isMounted && !isFetching) {
      dispatch(viewVisited(view));
    }
  }, [dispatch, isMounted, isFetching, view]);

  useEffect(() => {
    setIsMounted(true);
  }, [setIsMounted]);

  return { isViewVisited };
};

export default useViewVisited;
